<template></template>

<script setup lang="ts">
import auth from "@/auth";
import { onMounted } from "vue";
import { usePDF } from "@/stores/pdf";
import { ref } from 'vue';

const pdfStore = usePDF();
const generatepdf = () => {
  const image = document.getElementById("chart_pdf");
  pdfStore.downloadPDF(image);
};

// const redirect = () => {
//   auth.signinRedirect();
// };

const redirect = () => {
  const isSessionEmpty = ref(false);
    sessionStorage.clear(); // Clears the session storage
    localStorage.clear();
    isSessionEmpty.value = Object.keys(localStorage).length === 0;
      if (isSessionEmpty.value) {
              setTimeout(() => {
                auth.signinRedirect();
              }, 500);
            } else {
              sessionStorage.clear();
              localStorage.clear();
              setTimeout(() => {
                auth.signinRedirect();
              }, 500);
            }
  // auth.signinRedirect();
};
onMounted(() => {
  redirect();
});
onMounted(() => {
  redirect();
});
</script>

<!-- <template>
  <div class="container border">
    <button @click="test">test</button>
    <form
      class="needs-validation"
      id="form"
      @submit="auth.signinRedirect()"
      novalidate
    >
      <div class="row mb-3">
        <div class="col-1">
          <img class="nlb-logo" src="@/assets/nlb-logo.png" />
        </div>
        <div class="col-11">
          <h3>Login</h3>
        </div>
      </div>
      <div class="mb-3">
        <label for="username" class="form-label">Username</label>
        <input
          type="text"
          class="form-control"
          id="username"
          placeholder="Enter Username"
          v-model.trim="username"
          required
        />
        <div class="invalid-feedback">Please enter your username</div>
      </div>
      <div class="mb-3">
        <label for="password" class="form-label">Password</label>
        <div class="input-group">
          <input
            type="password"
            class="form-control"
            id="password"
            placeholder="Enter Password"
            v-model.trim="password"
            required
          />
          <i
            class="input-group-text bi bi-eye-slash"
            id="togglePassword"
            @click="showPassword"
          ></i>
          <div class="invalid-feedback">Please enter your password</div>
        </div>
      </div>
      <div class="mb-3">
        <div class="form-check">
          <input
            class="form-check-input"
            type="checkbox"
            value=""
            id="rememberMe"
          />
          <label class="form-check-label is-valid" for="rememberMe"
            >Remember Me</label
          >
        </div>
      </div>
      <div class="mb-3">
        <button class="btn btn-primary" type="submit" style="width: 100%">
          Login
        </button>
      </div>
    </form>
  </div>
</template>

<script setup lang="ts">
import auth from "@/auth";
import { useAuthenticationStore } from "@/stores/authentication";
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";

onMounted(() => {
  var forms = document.querySelectorAll(".needs-validation");
  Array.prototype.slice.call(forms).forEach((form) => {
    form.addEventListener(
      "submit",
      (event) => {
        if (!form.checkValidity()) {
          event.preventDefault();
          event.stopPropagation();
        }
        form.classList.add("was-validated");
      },
      false
    );
  });
});
const authenticationStore = useAuthenticationStore();
const username = ref("");
const password = ref("");

const test = () => {
  console.log("Here", auth);
};

const router = useRouter();

const showPassword = () => {
  let togglePassword: any = document.getElementById("togglePassword");
  let password: any = document.getElementById("password");
  if (password.getAttribute("type") == "password") {
    togglePassword.classList.remove("bi-eye-slash");
    togglePassword.classList.add("bi-eye");
    password.setAttribute("type", "text");
  } else {
    togglePassword.classList.remove("bi-eye");
    togglePassword.classList.add("bi-eye-slash");
    password.setAttribute("type", "password");
  }
};

const login = () => {
  if (username.value !== "" && password.value !== "") {
    authenticationStore.loginDetails(username.value, password.value, router);
  }
  authenticationStore.setUsername(username.value);
};
const initUsername = () => {
  username.value = authenticationStore.getUsername();
};

initUsername();
</script>

<style scoped>
.container {
  padding: 16px;
  margin: 16px auto;
  width: 420px;
  height: auto;
}

.nlb-logo {
  margin-top: 2px;
  width: 24px;
  height: 24px;
}
</style> -->
